import React from 'react';
import SwitchButton from 'components/customComponents/Controls/SwitchButton';

export type ImagingToggleProps = {
  label: string;
  isOn: boolean;
  onToggle: () => void;
  disabled?: boolean;
};

interface Props {
  toggles: ImagingToggleProps[];
}

const ImagingToggles = (props: Props) => {
  const { toggles } = props;
  return (
    <div id='commandpanel-exptools-imagingtoogles-wrapper' className="flex flex-row gap-4 flex-wrap">
      {toggles?.map((t, i) => (
        <div id='commandpanel-exptools-imagingtoogles-content'  key={`image-toggle-${i}`} className="flex flex-row gap-2">
          <span id={`commandpanel-exptools-imagingtoogles-${t.label}`} >{t.label}</span>
          <div
            id='commandpanel-exptools-imagingtoogles-cursor' 
            className={`${
              t.disabled ? 'opacity-40 pointer-events-none cursor-default' : ''
            }`}
          >
            <SwitchButton isOn={t.isOn} onToggle={t.onToggle} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ImagingToggles;
